module.exports = __webpack_public_path__ + "img/olympic-running.bc77e4ac.png";